module.exports = __webpack_public_path__ + "static/media/greyClose.810f395e.svg";